import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from 'vue';
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingInfo',
  props: [
  "is_logged_in", "email", 'show_country', 'show_county', 'show_city', 'show_postal',
  'show_tax', 'show_phone_no', 'show_company', 'show_anonymous_donation',
  'enable_test_card_information', "strings",
  'show_fee_recovery', 'fee_recovery_optin_mode', 'fee_recovery_optin_message',
  'fee_recovery_show_breakdown', 'fee_recovery_mode', 'fee_recovery_global',
  'fee_recovery_per_gateway', 'fee_recovery_currency'
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;
const countries = ref([]);
const select_loading = ref(false);
const country = ref('');
const lifeline_donation = globalThis.lifeline_donation;

const setValue = (key, val) => {
  store[key] = val;
};
const setBillingValue = (key, val: Event) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if (props.strings) {
    return props.strings[key];
  }
};
const getCountries = () => {
  select_loading.value = true;

  const $ = jQuery;

  $.ajax({
    url: lifeline_donation.homeurl+ '/wp-json/webinane-commerce/v1/countries',
    success: res => {
      countries.value = res.countries
    },
    complete: res => {
      select_loading.value = false
    }
  })
};

const feeRecoveryRate = computed(() => {
  const fallback = { percent: 0, flat: 0, max: 0 };
  if (props.fee_recovery_mode === 'per_gateway') {
    const map = props.fee_recovery_per_gateway || {};
    if (store.payment_method && map[store.payment_method]) {
      return map[store.payment_method];
    }
    const keys = Object.keys(map);
    if (keys.length > 0) {
      return map[keys[0]];
    }
  }
  return props.fee_recovery_global || fallback;
});

const feeRecoveryAmount = computed(() => {
  const base = parseFloat(String(store.amount)) || 0;
  if (base <= 0) return 0;
  const r: any = feeRecoveryRate.value || {};
  let fee = base * ((parseFloat(r.percent) || 0) / 100) + (parseFloat(r.flat) || 0);
  const max = parseFloat(r.max) || 0;
  if (max > 0 && fee > max) fee = max;
  return Math.max(0, Math.round(fee * 100) / 100);
});

const formatMoney = (n: number) => {
  const num = parseFloat(String(n)) || 0;
  return (props.fee_recovery_currency || '$') + num.toFixed(2);
};

const feeRecoveryMessage = computed(() => {
  const tpl = props.fee_recovery_optin_message || '';
  return tpl.replace('{fee_amount}', formatMoney(feeRecoveryAmount.value));
});

const feeRecoveryBreakdown = computed(() => {
  const donation = parseFloat(String(store.amount)) || 0;
  const opted = props.fee_recovery_optin_mode === 'forced' || !!store.extras.fee_recovery_optin;
  const fee = opted ? feeRecoveryAmount.value : 0;
  const total = donation + fee;
  const tpl = (props.strings && props.strings.fee_recovery_breakdown)
    || 'Donation: {donation}  +  Fee: {fee}  =  Total: {total}';
  return tpl
    .replace('{donation}', formatMoney(donation))
    .replace('{fee}', formatMoney(fee))
    .replace('{total}', formatMoney(total));
});

watch(
  [
    () => feeRecoveryAmount.value,
    () => store.amount,
    () => store.extras.fee_recovery_optin,
    () => props.fee_recovery_optin_mode,
    () => props.show_fee_recovery,
  ],
  () => {
    const opted = props.show_fee_recovery && (
      props.fee_recovery_optin_mode === 'forced' || !!store.extras.fee_recovery_optin
    );
    store.extras.fee_recovery_amount = opted ? feeRecoveryAmount.value : 0;
    store.extras.fee_recovery_base   = parseFloat(String(store.amount)) || 0;
  },
  { immediate: true }
);

onMounted(() => {
  if (props.show_fee_recovery && props.fee_recovery_optin_mode === 'forced') {
    store.extras.fee_recovery_optin = true;
  }
});


const __returned__ = { store, props, countries, select_loading, country, lifeline_donation, setValue, setBillingValue, trans, getCountries, feeRecoveryRate, feeRecoveryAmount, formatMoney, feeRecoveryMessage, feeRecoveryBreakdown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})